import PhoneInput from 'antd-phone-input';
import { useCallback } from 'react';

export interface PhoneNumberInputProps {
  numberInputProps?: any;
  onNumberChange?: (
    countryCode: number | null | undefined,
    value: string,
  ) => void;
}

export default function PhoneNumberInput({
  numberInputProps,
  onNumberChange,
}: PhoneNumberInputProps) {
  const handleChange = useCallback(
    ({ countryCode, areaCode, phoneNumber }: any) => {
      if (onNumberChange) {
        onNumberChange(countryCode, `${areaCode ?? ''}${phoneNumber ?? ''}`);
      }
    },
    [onNumberChange],
  );

  return (
    <PhoneInput
      enableArrow
      enableSearch
      disableParentheses
      onChange={handleChange}
      country="in"
      preferredCountries={['in']}
      {...numberInputProps}
    />
  );
}
